module.exports = __webpack_public_path__ + "media/images/faq/brand2-293d78237603b12068091a2c03d5c6d3.png";